import React from "react";
import { config } from "core/utils";
import useEnteredViewport from "core/customHooks/useEnteredViewport";
import { trackTopPicks } from "./utils/tracking";
import { View } from "./View";
import { getViewData } from "pages/home/components/TopPicksCollection/utils/getViewData";
export var Provider = function (_a) {
    var componentId = _a.componentId, collectionComponentId = _a.collectionComponentId, moreLink = _a.moreLink, title = _a.title, uuid = _a.uuid, listName = _a.listName, trackingEnabled = _a.trackingEnabled, topPickWeek = _a.topPickWeek;
    var _b = useEnteredViewport(config.tracking.impressionThreshold.default), ref = _b.ref, enteredViewport = _b.enteredViewport;
    if (trackingEnabled && enteredViewport) {
        trackTopPicks(listName, getViewData(topPickWeek, "vandaag"));
    }
    return (React.createElement(View, { componentId: componentId, collectionComponentId: collectionComponentId, title: title, uuid: uuid, moreLink: moreLink, ref: ref, topPickWeek: topPickWeek }));
};
